/**
 * Subscribe to a MediaQueryList across browsers and return an unsubscribe function.
 *
 * Legacy engines — UC Browser on Android in particular — expose only the
 * deprecated MediaQueryList.addListener/removeListener API and have no
 * addEventListener on the list, so calling addEventListener throws a TypeError.
 * Prefer the modern API and fall back to the deprecated one.
 */
export function subscribeToMediaQuery(
  media: MediaQueryList,
  onChange: () => void,
): () => void {
  if (typeof media.addEventListener === "function") {
    media.addEventListener("change", onChange)
    return () => media.removeEventListener("change", onChange)
  }

  media.addListener(onChange)
  return () => media.removeListener(onChange)
}
